import { render, staticRenderFns } from "./PeligroColorBar.vue?vue&type=template&id=2f43866a&scoped=true"
import script from "./PeligroColorBar.vue?vue&type=script&lang=ts"
export * from "./PeligroColorBar.vue?vue&type=script&lang=ts"
import style0 from "./PeligroColorBar.vue?vue&type=style&index=0&id=2f43866a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f43866a",
  null
  
)

export default component.exports